import React, { useEffect, useState } from "react";
import styles from "./eventPreview.module.css";
import { useNavigate, useParams } from "react-router-dom";
import { getData } from "utils/queries";
import { formatDateFromDateAndTime } from "utils";

const EventPreview = () => {
  const [data, setData] = useState();
  const [tickets, setTickets] = useState();

  const { event_id } = useParams();


  const navigate = useNavigate();

  const fetchData = async (event_id) => {
    try {
      const eventQuery = getData(`event/events/${event_id}`);
      const ticketQuery = getData(`ticket/tickets/events/${event_id}`);

      const promisifiedResult = await Promise.all([eventQuery, ticketQuery]);

      const [eventResult = null, ticketResult = null] = promisifiedResult;

      if (eventResult?.data?.data?.events) {
        if (eventResult?.data?.data?.events) {
          setData(eventResult?.data?.data?.events);
        }
      }

      if (ticketResult?.data) {
        if (ticketResult?.data) {
          setTickets(ticketResult?.data);
        }
      }


 
    } catch (error) {
    }
  };

  useEffect(() => {
    if (event_id) {
      fetchData(event_id);
    }
  }, [event_id]);


  return (
    data?.event_name && (
      <>
        <div className={styles.headerWr}>
          <div className={styles.previewLabel}>Preview</div>
          <img
            src="/icons/cancel.svg"
            alt="cancel"
            onClick={() => navigate(`/event/event-details/${event_id}`)}
            style={{ cursor: "pointer" }}
          />
        </div>
        <div className={styles.container}>
          <div className={styles.imageWrapper}>
            <img
              src={data?.event_image}
              alt="event"
              style={{  margin: "0 auto", display: "block",    maxHeight: "50vh" }}
            />
          </div>

          <div className={styles.eventInfo}>
            <div className={styles.label}>{data.event_name}</div>
            <div className={styles.info}>
              <div className={styles.makeFlex}>
                <img src="/icons/clock.svg" alt="clock" />
                {formatDateFromDateAndTime(data?.starts)} - 
                {formatDateFromDateAndTime(data?.ends)}
              </div>
              <div className={styles.makeFlex}>
                <img src="/icons/location.svg" alt="location" />

                {data?.venue}
              </div>
              <div className={styles.makeFlex}>
                <img src="/icons/ticketBlack.svg" alt="ticket" />
                Available
              </div>
              <div className={styles.restrictions}>
                <span>
                  Last Entry Date:{" "}
                  {formatDateFromDateAndTime(data?.last_entry_time)}
                </span>
                <span>
                  Age Restriction : {data?.age_restrictions || "NA"}{" "}
                </span>
              </div>
            </div>
          </div>

          <div className={styles.ticketInfo}>
            <div className={styles.label_}>Tickets</div>
            {tickets?.length > 0 ? (
              tickets?.map((e, i) => {
                return (
                  <div className={styles.data}>
                    <div className={styles.details}>
                      <div className={styles.label}>{e?.price}£ Ticket</div>
                      <div className={styles.value}>Valid all night</div>
                    </div>

                    <div className={styles.details}>
                      <div className={styles.label}>Off Sales</div>
                      <div className={styles.value}>
                        £{e?.price} + Booking Fee
                      </div>
                    </div>

                    <div className={styles.details}>
                      <div className={styles.label}>Quantity </div>
                      <div className={styles.value}>{e?.quantity_available}</div>
                    </div>
                  </div>
                );
              })
            ) : (
              <div>No Tickets </div>
            )}
          </div>

          <div className={styles.description}>
            <div className={styles.label}>About</div>
            <div className={styles.subLabel}>
              {/* LIVERPOOL BIGGEST TUESDAY NIGHT - TRICK 🎉 */}
            </div>
            <div className="">
              <div className={styles.value}
                dangerouslySetInnerHTML={{ __html: data?.event_description }}
              />
            </div>
          </div>

          <div className={styles.venueInfo}>
            <div className={styles.label_}>Venue</div>
            <div className={styles.subLabel}></div> 
            <div className={styles.value}>{data.venue}</div>
          </div>
        </div>
      </>
    )
  );
};

export default EventPreview;
